// Ð¨Ð°Ð³Ð¸ Ð¾Ð±ÑÑÐµÐ½Ð¸Ñ: ÑÑÐ¾ Ð¾ÑÐºÑÑÑÑ, ÑÑÐ¾ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¸ÑÑ Ð¸ ÐºÐ°ÐºÐ¸Ð¼ ÑÐµÐºÑÑÐ¾Ð¼ Ð¾Ð±ÑÑÑÐ½Ð¸ÑÑ.
//
// ÐÐ°Ðº Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÑ ÑÐ°Ð³:
//   1. Ð¿Ð¾Ð²ÐµÑÑÑÐµ Ð½Ð° ÑÐ»ÐµÐ¼ÐµÐ½Ñ Ð°ÑÑÐ¸Ð±ÑÑ data-tour="Ð¸Ð¼Ñ" (ÑÐ¼. ANCHORS Ð½Ð¸Ð¶Ðµ);
//   2. Ð´Ð¾Ð±Ð°Ð²ÑÑÐµ ÑÐµÐºÑÑ Ð² locales/ru.js â steps.<ÐºÐ»ÑÑ>;
//   3. Ð²Ð¿Ð¸ÑÐ¸ÑÐµ ÑÑÐ´Ð° ÑÑÑÐ¾ÐºÑ { id, anchor, textKey } Ð² Ð½ÑÐ¶Ð½Ð¾Ð¼ Ð¼ÐµÑÑÐµ ÑÐ¿Ð¸ÑÐºÐ°.
//
// Ð¨Ð°Ð³, ÑÐ»ÐµÐ¼ÐµÐ½ÑÐ° ÐºÐ¾ÑÐ¾ÑÐ¾Ð³Ð¾ Ð½ÐµÑ Ð½Ð° ÑÑÑÐ°Ð½Ð¸ÑÐµ (Ð½ÐµÑ Ð¿ÑÐ°Ð² Ð½Ð° ÑÐ°Ð·Ð´ÐµÐ», ÑÐ·ÐºÐ¸Ð¹ ÑÐºÑÐ°Ð½),
// Ð¿ÑÐ¾Ð¿ÑÑÐºÐ°ÐµÑÑÑ ÑÐ°Ð¼ â Ð¿ÑÐ¾Ð²ÐµÑÑÑÑ Ð¿ÑÐ°Ð²Ð° Ð·Ð´ÐµÑÑ Ð½Ðµ Ð½ÑÐ¶Ð½Ð¾.

// ÐÑÐ½ÐºÑÑ ÑÐµÐº-Ð»Ð¸ÑÑÐ° Ð¿ÐµÑÐ²ÑÑ ÑÐ°Ð³Ð¾Ð², Ð¿Ð¾ Ð¿Ð¾ÑÑÐ´ÐºÑ: Ð¿ÑÑÑ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÐ° Ð´Ð¾ Ð¿ÐµÑÐ²Ð¾Ð¹ Ð·Ð°ÑÐ²ÐºÐ¸.
export const CHECKLIST_ITEMS = ['profile', 'client', 'deal', 'application', 'decisions'];

// ÐÐ¼ÐµÐ½Ð° ÑÐºÐ¾ÑÐµÐ¹ Ð´ÐµÑÐ¶Ð¸Ð¼ Ð² Ð¾Ð´Ð½Ð¾Ð¼ Ð¼ÐµÑÑÐµ: ÑÐ°Ðº Ð²Ð¸Ð´Ð½Ð¾, ÐºÐ°ÐºÐ¸Ðµ Ð°ÑÑÐ¸Ð±ÑÑÑ data-tour
// Ð´Ð¾Ð»Ð¶Ð½Ñ ÑÑÐ¾ÑÑÑ Ð² ÑÐ°Ð·Ð¼ÐµÑÐºÐµ, Ð¸ Ð¾Ð¿ÐµÑÐ°ÑÐºÐ° Ð² ÑÐµÐ»ÐµÐºÑÐ¾ÑÐµ Ð½Ðµ Ð¾ÑÑÐ°ÑÑÑÑ Ð½ÐµÐ·Ð°Ð¼ÐµÑÐµÐ½Ð½Ð¾Ð¹.
export const ANCHORS = {
  sidebar: 'sidebar',
  menuClients: 'menu-clients',
  menuLeads: 'menu-leads',
  menuDeals: 'menu-deals',
  menuCars: 'menu-cars',
  menuProfile: 'menu-profile',
  tableSearch: 'table-search',
  tableFilters: 'table-filters',
  tableAdd: 'table-add',
  headerUser: 'header-user',
  sidebarHelp: 'sidebar-help',
};

export const selectorFor = (anchor) => `[data-tour="${anchor}"]`;

// ÐÐ¾Ð»Ñ ÑÐ°Ð³Ð°:
//   anchor    â ÑÑÐ¾ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¸ÑÑ;
//   route     â ÐºÐ°ÐºÐ¾Ð¹ ÑÐ°Ð·Ð´ÐµÐ» Ð¾ÑÐºÑÑÑÑ Ð¿ÐµÑÐµÐ´ Ð¿Ð¾ÐºÐ°Ð·Ð¾Ð¼. ÐÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð²Ð¸Ð´Ð¸Ñ Ð¶Ð¸Ð²ÑÑ
//               ÑÑÑÐ°Ð½Ð¸ÑÑ ÑÐ¾ ÑÐ²Ð¾Ð¸Ð¼Ð¸ ÐºÐ»Ð¸ÐµÐ½ÑÐ°Ð¼Ð¸ Ð¸ ÑÐ´ÐµÐ»ÐºÐ°Ð¼Ð¸, Ð° Ð½Ðµ ÑÐ»ÑÑÐ°ÐµÑ Ð¿ÑÐ¾ Ð½ÐµÑ
//               Ñ ÑÑÐ¶Ð¾Ð³Ð¾ ÑÐºÑÐ°Ð½Ð°;
//   requires  â Ð¿Ð¾ ÑÐµÐ¼Ñ ÑÑÐ´Ð¸ÑÑ, Ð½ÑÐ¶ÐµÐ½ Ð»Ð¸ ÑÐ°Ð³ Ð²Ð¾Ð¾Ð±ÑÐµ. Ð£ ÑÐ°Ð³Ð° Ñ Ð¿ÐµÑÐµÑÐ¾Ð´Ð¾Ð¼ ÑÑÐ¾
//               Ð¿ÑÐ½ÐºÑ Ð¼ÐµÐ½Ñ: Ð½ÐµÑ Ð¿ÑÐ½ÐºÑÐ° â Ð½ÐµÑ ÑÐ°Ð·Ð´ÐµÐ»Ð°, Ð¾ÑÐºÑÑÐ²Ð°ÑÑ Ð½ÐµÑÐµÐ³Ð¾;
//   placement â Ð¶ÐµÐ»Ð°ÐµÐ¼Ð°Ñ ÑÑÐ¾ÑÐ¾Ð½Ð° ÐºÐ°ÑÑÐ¾ÑÐºÐ¸.
const STEPS = [
  { id: 'welcome', anchor: null, textKey: 'welcome', placement: 'center' },
  { id: 'sidebar', anchor: ANCHORS.sidebar, textKey: 'sidebar', placement: 'right' },

  // ÐÐ»Ð¸ÐµÐ½ÑÑ: Ð¾ÑÐºÑÑÐ²Ð°ÐµÐ¼ ÐºÐ°ÑÑÐ¾ÑÐµÐºÑ Ð¸ Ð½Ð° Ð½ÐµÐ¹ Ð¶Ðµ ÑÐ°Ð·Ð±Ð¸ÑÐ°ÐµÐ¼ ÑÐ¾, ÑÑÐ¾ Ð¾Ð´Ð¸Ð½Ð°ÐºÐ¾Ð²Ð¾
  // Ð²Ð¾ Ð²ÑÐµÑ ÑÐ¿Ð¸ÑÐºÐ°Ñ â ÐºÐ½Ð¾Ð¿ÐºÑ Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½Ð¸Ñ, Ð±ÑÑÑÑÑÐ¹ Ð¿Ð¾Ð¸ÑÐº, Ð¾ÑÐ±Ð¾Ñ Ð¿Ð¾ ÑÑÐ»Ð¾Ð²Ð¸ÑÐ¼.
  {
    id: 'clients',
    anchor: ANCHORS.menuClients,
    route: '/',
    requires: ANCHORS.menuClients,
    textKey: 'clients',
    placement: 'right',
  },
  {
    id: 'addClient',
    anchor: ANCHORS.tableAdd,
    route: '/',
    requires: ANCHORS.menuClients,
    textKey: 'addClient',
    placement: 'bottom',
  },
  {
    id: 'search',
    anchor: ANCHORS.tableSearch,
    route: '/',
    requires: ANCHORS.menuClients,
    textKey: 'search',
    placement: 'bottom',
  },
  {
    id: 'filters',
    anchor: ANCHORS.tableFilters,
    route: '/',
    requires: ANCHORS.menuClients,
    textKey: 'filters',
    placement: 'bottom',
  },

  {
    id: 'leads',
    anchor: ANCHORS.menuLeads,
    route: '/leads',
    requires: ANCHORS.menuLeads,
    textKey: 'leads',
    placement: 'right',
  },
  {
    id: 'deals',
    anchor: ANCHORS.menuDeals,
    route: '/deals',
    requires: ANCHORS.menuDeals,
    textKey: 'deals',
    placement: 'right',
  },
  {
    id: 'createDeal',
    anchor: ANCHORS.tableAdd,
    route: '/deals',
    requires: ANCHORS.menuDeals,
    textKey: 'createDeal',
    placement: 'bottom',
  },
  {
    id: 'cars',
    anchor: ANCHORS.menuCars,
    route: '/cars',
    requires: ANCHORS.menuCars,
    textKey: 'cars',
    placement: 'right',
  },
  {
    id: 'addCar',
    anchor: ANCHORS.tableAdd,
    route: '/cars',
    requires: ANCHORS.menuCars,
    textKey: 'addCar',
    placement: 'bottom',
  },

  { id: 'credit', anchor: null, textKey: 'credit', placement: 'center' },
  { id: 'decisions', anchor: null, textKey: 'decisions', placement: 'center' },
  {
    id: 'profile',
    anchor: ANCHORS.menuProfile,
    requires: ANCHORS.sidebar,
    textKey: 'profile',
    placement: 'right',
  },
  {
    id: 'help',
    anchor: ANCHORS.sidebarHelp,
    requires: ANCHORS.sidebar,
    textKey: 'help',
    placement: 'right',
  },
];

const isVisible = (node) => {
  if (!node) return false;

  // Ð¡Ð¿ÑÑÑÐ°Ð½Ð½Ð¾Ðµ ÑÐ¾Ð²ÑÐµÐ¼ (ÑÑÐ¶Ð°Ñ ÑÐ¾Ð»Ñ, Ð¿ÐµÑÐ°ÑÐ½Ð°Ñ Ð²ÐµÑÑÐ¸Ñ) Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¸Ð²Ð°ÑÑ Ð½ÐµÑÐµÐ¼.
  if (typeof window !== 'undefined' && typeof window.getComputedStyle === 'function') {
    const style = window.getComputedStyle(node);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
  }

  // Ð£ÐµÑÐ°Ð»Ð¾ Ð·Ð° ÐºÑÐ°Ð¹ ÑÐºÑÐ°Ð½Ð° â ÑÐ°Ðº Ð½Ð° ÑÐµÐ»ÐµÑÐ¾Ð½Ðµ ÑÑÐ¾Ð¸Ñ Ð·Ð°ÐºÑÑÑÐ¾Ðµ Ð±Ð¾ÐºÐ¾Ð²Ð¾Ðµ Ð¼ÐµÐ½Ñ:
  // ÑÐ»ÐµÐ¼ÐµÐ½Ñ ÐµÑÑÑ, Ð½Ð¾ ÑÐ´Ð²Ð¸Ð½ÑÑ Ð²Ð»ÐµÐ²Ð¾ Ð·Ð° Ð³ÑÐ°Ð½Ð¸ÑÑ Ð¾ÐºÐ½Ð°.
  const rect = typeof node.getBoundingClientRect === 'function' ? node.getBoundingClientRect() : null;
  if (rect && (rect.right < 0 || rect.bottom < 0 || rect.left > window.innerWidth || rect.top > window.innerHeight)) {
    return false;
  }

  return true;
};

// Ð¨Ð°Ð³ Ð±ÐµÐ· ÑÐºÐ¾ÑÑ (ÑÐ°ÑÑÐºÐ°Ð· Ð±ÐµÐ· Ð¿Ð¾Ð´ÑÐ²ÐµÑÐºÐ¸) Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ Ð²ÑÐµÐ³Ð´Ð°. Ð¨Ð°Ð³ Ñ Ð¿ÐµÑÐµÑÐ¾Ð´Ð¾Ð¼
// ÑÑÐ´Ð¸Ð¼ Ð¿Ð¾ Ð¿ÑÐ½ÐºÑÑ Ð¼ÐµÐ½Ñ: Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¸Ð²Ð°ÐµÐ¼ÑÐ¹ ÑÐ»ÐµÐ¼ÐµÐ½Ñ Ð¿Ð¾ÑÐ²Ð¸ÑÑÑ ÑÐ¾Ð»ÑÐºÐ¾ Ð¿Ð¾ÑÐ»Ðµ Ð¿ÐµÑÐµÑÐ¾Ð´Ð°,
// Ð¸ Ð¿ÑÐ¾Ð²ÐµÑÑÑÑ ÐµÐ³Ð¾ Ð½Ð° ÑÐµÐºÑÑÐµÐ¹ ÑÑÑÐ°Ð½Ð¸ÑÐµ Ð±ÐµÑÑÐ¼ÑÑÐ»ÐµÐ½Ð½Ð¾.
export const isStepAvailable = (step, doc = document) => {
  const marker = step.requires || step.anchor;
  if (!marker) return true;

  return isVisible(doc.querySelector(selectorFor(marker)));
};

export const availableSteps = (doc = document) => STEPS.filter((step) => isStepAvailable(step, doc));

export default STEPS;
